import { Injectable } from '@angular/core';
import { AuthService } from '../auth.service';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';



@Injectable({
  providedIn: 'root'
})

export class LoggingService {


user;
username;

constructor(public auth: AuthService, public http:HttpClient) {

  this.auth.userProfile$.subscribe(
    (profile) => {

      this.user = profile;
      this.username = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
    });

 }



  private baseURL = environment.baseUrl;



  debug(message: string)   {
    let logEntry = this.createLogStatement('debug', message);

        this.http.post(this.baseURL + '/rhAPI/log/' + 2, {message : logEntry}, {observe: 'body'}).subscribe(
      res=>{
      },err => {
      });

    return logEntry;
  }

  error(message: string) {
    let logEntry = this.createLogStatement('error', message);

        this.http.post(this.baseURL + '/rhAPI/log/' + 4, {message : logEntry}, {observe: 'body'}).subscribe(
      res=>{
      },err => {
      });

    return logEntry;
  }

  warn(message: string)  {
    let logEntry = this.createLogStatement('warning', message);
        this.http.post(this.baseURL + '/rhAPI/log/' + 3, {message : logEntry}, {observe: 'body'}).subscribe(
      res=>{
      },err => {
      });

    return logEntry;
  }

  info(message: string) {
    let logEntry = this.createLogStatement('info', message);
    this.http.post(this.baseURL + '/rhAPI/log/' + 1, {message : logEntry}, {observe: 'body'}).subscribe(
      res=>{
      },err => {
      });

    return logEntry;
  }

  createLogStatement (level, message) {
    let SEPARATOR = ": ";
    let date = this.getCurrentDate();
    return "[" + level + "]" + SEPARATOR + date + SEPARATOR  + message;
  }

  getCurrentDate () {
    let now = new Date();
    return "[" + now.toLocaleString("en-US") + "]";
  }

  safeStringify(value) {
  try {
    return JSON.stringify(value);
  } catch {
    return String(value);
  }
}

}
